import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

const Title = styled.h2`
  color: #e91e63;
  margin-bottom: 1rem;
`;

const OptionContainer = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const OptionButton = styled.button`
  flex: 1;
  padding: 1.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 8px;
  border: 1px solid #e91e63;
  background-color: white;
  color: #e91e63;
  transition: all 0.2s;

  &:hover {
    background-color: #fff5f8;
    transform: translateY(-3px);
  }
`;

const GenderSelection = ({ onSelectGender }) => (
  <Container>
    <Title>Who would you like to practice with?</Title>
    <OptionContainer>
      <OptionButton onClick={() => onSelectGender('female')}>Women</OptionButton>
      <OptionButton onClick={() => onSelectGender('male')}>Men</OptionButton>
    </OptionContainer>
  </Container>
);

export default GenderSelection;
